<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="帐号" prop="username">
        <Input v-model="formValidate.username" placeholder="请输入员工帐号"></Input>
      </FormItem>
      <FormItem label="密码" :prop="password" v-if="idAddForm">
        <Input
        type="password"
          v-model="formValidate.password"
          placeholder="请输入密码"
        ></Input>
      </FormItem>
      <FormItem label="真实姓名" prop="realName">
        <Input
          v-model="formValidate.realName"
          placeholder="请输入真实姓名"
        ></Input>
      </FormItem>
      <FormItem label="身份证">
        <Input
          v-model="formValidate.idCard"
          placeholder="请输入身份证"
        ></Input>
      </FormItem>
      <FormItem label="手机号" prop="phone">
        <Input
          v-model="formValidate.phone"
          placeholder="请输入手机号"
        ></Input>
      </FormItem>
      <FormItem label="邮箱">
        <Input
          v-model="formValidate.email"
          placeholder="请输入邮箱"
        ></Input>
      </FormItem>

      <FormItem label="所属分类" v-if="classifyIds.length > 1" prop="classify_id">
        <Select v-model="formValidate.classify_id">
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="门店">
        <Select v-model="formValidate.factoryId">
          <Option
            v-for="item in factoryIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="职位列表" prop="roles">
        <Transfer
          :titles="['未选', '已选']"
          :data="roleList"
          :target-keys="formValidate.roles"
          filterable
          :filter-method="filterMethod"
          @on-change="handleChange"
        ></Transfer>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      factoryIds: [],
      classifyIds: [],
      roleList: [],
      idAddForm: true,
      password: 'password',
      formValidate: {
        id: '',
        username: '',
        password: '',
        realName: '',
        idCard: '',
        phone: '',
        email: '',
        factoryId: '',
        classify_id:'',
        roles: []
      },
      ruleValidate: {
        username: [
          {
            required: true,
            message: '帐号不能为空',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          }
        ],
        idCard: [
          {
            required: true,
            message: '职位代码不能为空',
            trigger: 'blur'
          }
        ],
        factoryId: [
          {
            required: true,
            message: '必须选择门店',
            trigger: 'change'
          }
        ],
        roles: [
          {
            required: true,
            message: '必须选择职位'
          }
        ],
        classify_id: [
          {
            required: true,
            message: '必须选择产品分类',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setFactoryData (factoryList) {
      var data = new Array()
      for (var i = 0; i < factoryList.length; i++) {
        data[i] = { id: factoryList[i].id.toString(), name: factoryList[i].name }
      }
      this.factoryIds = data
    },
    setClassifyData (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    setRoleData (roleList) {
      var data = new Array()
      for (var i = 0; i < roleList.length; i++) {
        data[i] = { key: roleList[i].id, label: roleList[i].name }
      }
      this.roleList = data
    },
    setAddData () {
      this.idAddForm = true
      this.password = 'password'
    },
    setEditData (data) {
      this.idAddForm = false
      this.password = ''
      this.formValidate.id = data.id
      this.formValidate.username = data.username
      this.formValidate.password = data.password
      this.formValidate.realName = data.real_name
      this.formValidate.idCard = data.id_card
      this.formValidate.phone = data.phone
      this.formValidate.email = data.email
      this.formValidate.classify_id = data.classify_id.toString()
      this.formValidate.factoryId = data.factory_id.toString()
      this.formValidate.roles = data.roles
    },
    handleChange (newTargetKeys) {
      this.formValidate.roles = newTargetKeys
    },
    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
